import { toCapitalize } from 'helpers/toCapitalize';
import parse from 'html-react-parser'
import { Box, Grid, Paper } from "@mui/material";
import TeacherAvatar from 'components/common/TeacherAvatar';
import { fetchWithToken, fetchWithTokenToUploadImage } from 'helpers/fetch';
import { endPoints } from 'const/endPoints';
import { 
  Typography, 
  Slide,
  Button,
  IconButton,
  Tooltip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from "@mui/material";
import React, { useState } from 'react';
import { Edit as EditIcon, PhotoCamera } from "@mui/icons-material";
import ClipLoader from "react-spinners/ClipLoader";
import CustomToast from 'components/common/CustomToast';
import { useToast } from 'hooks/useToast';
import { useSelector } from 'react-redux';
import ReactQuill from 'react-quill';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export const TeacherCard = ({ teacher, flag, setFlag, courseId }) => {
  const user = useSelector((state) => state.auth.user);
  const { id, firstName, lastName, image, username, about } = teacher;
  const [openDialog, setDialog] = useState(false);
  const [openImageDialog, setImageDialog] = useState(false);
  const handleClickOpen = () => setDialog(true);
  const handleCloseDialog = () => setDialog(false);
  const handleImageClickOpen = () => setImageDialog(true);
  const handleImageCloseDialog = () => setImageDialog(false);
  const name = toCapitalize(`${firstName} ${lastName}`);
  const [loading, setLoading] = useState(false);
  const [imageLoading, setImageLoading] = useState(false);
  const [updateAbout, setUpdateAbout] = useState(about);
  const [selectedFile, setSelectedFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [thereFile, setTherefile] = useState(false);
  const { toast, showToast, hideToast } = useToast();

  const handleUpdateAbout = async () => {
    setLoading(true)
    const resp = await fetchWithToken(`${endPoints.update_teacher_about}/${id}`, { about: updateAbout }, 'PUT')
    const body = await resp.json();
    if (body.statusCode === 200) {
      showToast('success', body.message);
      setFlag(!flag)
    }
    else {
      showToast('error', body.message);
    }
    setLoading(false);
  }

  const handleFileSelect = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedFile(file);
      setTherefile(true);
      
      // Crear preview de la imagen
      const reader = new FileReader();
      reader.onload = (e) => {
        setPreviewUrl(e.target.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleUploadImage = async () => {
    if (!selectedFile) {
      showToast('error', 'Por favor selecciona una imagen');
      return;
    }

    setImageLoading(true);
    try {
      // Crear FormData para enviar la imagen
      const formData = new FormData();
      formData.append('image', selectedFile);
      
      // Llamar al endpoint para guardar en DigitalOcean Spaces y actualizar DB
      const resp = await fetchWithTokenToUploadImage(
        `${endPoints.upload_teacher_image_local}/${id}`, 
        formData, 
        'PUT'
      );
      
      const body = await resp.json();
      if (resp.status === 200 && body.message === 'Imagen subida exitosamente') {
        // Cerrar el modal primero
        handleImageCloseDialog();
        
        // Limpiar estados
        setSelectedFile(null);
        setPreviewUrl(null);
        setTherefile(false);
        
        // Mostrar toast de éxito
        showToast('success', '¡Imagen del profesor actualizada correctamente!');
        
        // Actualizar la vista para mostrar la nueva imagen
        setFlag(!flag);
      } else {
        showToast('error', body.message || 'Error al actualizar la imagen');
      }
    } catch (error) {
      console.error('Error:', error);
      showToast('error', 'Error al subir la imagen');
    }
    setImageLoading(false);
  };

  return (
    <>
      {openDialog && (<Dialog
        open={openDialog}
        fullWidth={true}
        draggable={true}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleCloseDialog}
        describedby="alert-dialog-slide-description"
      >
        <DialogTitle>{"Actualizar descripción del maestro"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            <ReactQuill scrollingContainer={'true'} theme="snow" value={updateAbout} onChange={setUpdateAbout} />
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              handleUpdateAbout()
              handleCloseDialog();
            }}
          >
            Guardar
            {loading && <ClipLoader color={"white"} size={30} />}
          </Button>
        </DialogActions>
      </Dialog>)}

      {openImageDialog && (<Dialog
        open={openImageDialog}
        fullWidth={true}
        draggable={true}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleImageCloseDialog}
        describedby="alert-dialog-image-description"
      >
        <DialogTitle>{"Subir foto del maestro"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-image-description">
            <Box display="flex" flexDirection="column" alignItems="center">
              <label htmlFor={`icon-button-file-${id}`} style={{ marginBottom: 16 }}>
                <input
                  accept="image/*"
                  id={`icon-button-file-${id}`}
                  type="file"
                  style={{ display: "none" }}
                  onChange={handleFileSelect}
                />
                <IconButton
                  color="primary"
                  aria-label="upload picture"
                  component="span"
                  style={{
                    width: 120,
                    height: 120,
                    backgroundImage: previewUrl 
                      ? `url(${previewUrl})` 
                      : (image ? `url(${image.startsWith('http') ? image : `/images/teachers/${image}`})` : 'none'),
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                    backgroundColor: "#f0f0f0",
                    border: "3px dashed #1976d2",
                    borderRadius: "50%",
                  }}
                >
                  {!previewUrl && !image && <PhotoCamera style={{ fontSize: 40, color: '#1976d2' }} />}
                </IconButton>
              </label>
              <Typography variant="body2" color="textSecondary" align="center" style={{ marginBottom: 8 }}>
                {thereFile 
                  ? `Imagen seleccionada: ${selectedFile?.name}` 
                  : "Haz clic para seleccionar una imagen"}
              </Typography>
              <Typography variant="caption" color="textSecondary" align="center">
                Formatos admitidos: JPG, PNG, GIF (máx. 5MB)
              </Typography>
            </Box>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleImageCloseDialog}>
            Cancelar
          </Button>
          <Button
            onClick={handleUploadImage}
            disabled={!thereFile || imageLoading}
            variant="contained"
            color="primary"
          >
            Subir Imagen
            {imageLoading && <ClipLoader color={"white"} size={20} />}
          </Button>
        </DialogActions>
      </Dialog>)}
      <Paper style={{ padding: 14, marginTop: 20 }}>
        <Box >
        </Box>
        <Grid container wrap="nowrap" spacing={2}>
          <Grid item>
            <TeacherAvatar 
              teacher={teacher} 
              size={56} 
              showBorder={true} 
              elevation={true} 
            />
          </Grid>
          <Grid item xs zeroMinWidth>
            <Box display="flex" flexDirection="row" justifyContent="space-between" alignItems="flex-start">
              <h3 style={{ margin: 0, textAlign: "left" }}>{name}<br /><span style={{}}>{username}</span></h3>
              {user && user.role === 'admin' && <Box display="flex" flexDirection="row" style={{ gap: 8 }}>
                <Tooltip title={openDialog ? "" : "Actualizar descripción del maestro"}>
                  <IconButton onClick={() => {
                    handleClickOpen()
                  }} color="primary">
                    <EditIcon />
                  </IconButton>
                </Tooltip>
                <Tooltip title={openImageDialog ? "" : "Actualizar foto del maestro"}>
                  <IconButton onClick={() => {
                    handleImageClickOpen()
                  }} color="primary">
                    <PhotoCamera />
                  </IconButton>
                </Tooltip>
              </Box>
              }
              <Box
                style={{
                  width: 200,
                  display: 'flex',
                  alignItems: 'center',
                  marginLeft: 24
                }}
              >
              </Box>
            </Box>
            <div style={{ textAlign: "left" }}>
              {parse(about)}
            </div>
          </Grid>
        </Grid>
      </Paper >
      
      {/* Custom Toast */}
      <CustomToast
        type={toast.type}
        message={toast.message}
        open={toast.open}
        onClose={hideToast}
      />
    </>
  );
};